import * as S from './Image.styles';
import ImageSource from './imageSource.inner';

const defaultProps = {
  cursor: 'default' as 'not-allowed' | 'pointer' | 'default' | 'none',
  height: 24 as number,
  modifier: 'regular' as 'regular' | 'strong' | 'weak' | 'inverted',
  variant: 'primary' as
    | 'primary'
    | 'secondary-1'
    | 'secondary-2'
    | 'secondary-3'
    | 'neutral'
    | 'danger'
    | 'warning'
    | 'info'
    | 'success',
  width: 24 as number,
  disabled: false as boolean,
};

type ImageProps = {
  name: string;
  onClick?: () => any;
} & typeof defaultProps;

const Image = (props: ImageProps) => {
  const { disabled, variant, cursor, modifier, width, height } = props;
  const CurrentImage = ImageSource[`${props.name}`] || false;
  return (
    CurrentImage && (
      <S.Image
        variant={disabled ? 'neutral' : variant}
        cursor={disabled ? 'none' : cursor}
        modifier={disabled ? 'regular' : modifier}
        data-testid={`image-${props.name}`}
        onClick={disabled ? undefined : props.onClick}
        disabled={disabled}
      >
        <CurrentImage width={width} height={height} />
      </S.Image>
    )
  );
};

Image.defaultProps = defaultProps;

export default Image;
